<template>
	<div class="main_section meal-management-page p-3">

		<div v-if="$route.name === 'meal_management'">
			<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer float-right">
				<span class="cursor-pointer flex i18n-locale"><img class="w-6 h-6" :src="require(`@/assets/images/flags/${$i18n.locale}.png`)" :alt="$i18n.locale" /><span class="hidden sm:block ml-2"></span></span>
				<vs-dropdown-menu class="w-50 i18n-dropdown">
					<vs-dropdown-item @click="updateLocale('en')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/en.png" alt="en" /> &nbsp;{{ $t('en') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('pt')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/pt.png" alt="pt" /> &nbsp;{{ $t('pt') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('br')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/br.png" alt="br" /> &nbsp;{{ $t('br') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('de')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/de.png" alt="de" /> &nbsp;{{ $t('de') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('fr')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/fr.png" alt="fr" /> &nbsp;{{ $t('fr') }}</vs-dropdown-item>
					<vs-dropdown-item @click="updateLocale('es')"><img class="w-6 h-6 mr-1" src="@/assets/images/flags/es.png" alt="es" /> &nbsp;{{ $t('es') }}</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>

        <div class="mb-4"> 
			<h1 :class="(($route.name === 'meal_management')) ? 'my-5' : ''">{{$t('meal_management')}}</h1>
			<h4 class="mt-2">{{user.hotel.hotel_name}}</h4>
		</div>

		<vx-card class="stats-card">
			<div class="lg:w-1/2 w-full">
				<div class="vx-row">
					<div class="vx-col md:w-1/2 lg:w-2/4 w-full">
						<small class="block">{{$t('space')}}</small>
						<v-select class="w-full"
							:searchable="false"
							v-model="space_selected"
							:options="space_list"
							label="space_name"
							placeholder="---">
							<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
						</v-select>
					</div>
					<div class="vx-col md:w-1/2 lg:w-2/4 w-full">
						<small class="block">{{$t('service_type')}}</small>
						<v-select class="w-full"
							:searchable="false"
							v-model="service_type_selected"
							:options="service_type_list"
							:label="'name_'+$i18n.locale"
							placeholder="---">
							<span slot="no-options">{{$t('vSelectNoOptions')}}</span>
                		</v-select>
					</div>
				</div>
			</div>
		</vx-card>

		<div class="vx-row mt-8 mb-4" v-if="show_stats">
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4">
				<vx-card>
					<div class="flex items-center mb-2" style="gap: 1rem;">
						<div class="icon-wrapper iw-purple">
							<feather-icon icon="UserIcon" class="icon" />
						</div>
						<div>
						<h3 class="text-h3 m-0"><b>{{ previsao_total }}</b></h3>
						<div class="text-sm">{{ $t('forecast') }}</div>
					</div>
				</div>
				</vx-card>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4">
				<vx-card>
					<div class="flex items-center mb-2" style="gap: 1rem;">
						<div class="icon-wrapper iw-yellow">
							<feather-icon icon="UserIcon" class="icon" />
						</div>
						<div>
						<h3 class="text-h3 m-0"><b>{{ marcacoes }}</b></h3>
						<div class="text-sm">{{ $t('appointments') }}</div>
					</div>
				</div>
				</vx-card>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4">
				<vx-card>
					<div class="flex items-center mb-2" style="gap: 1rem;">
						<div class="icon-wrapper iw-green">
							<feather-icon icon="UserIcon" class="icon" />
						</div>
						<div>
						<h3 class="text-h3 m-0"><b>{{ presencas }}</b></h3>
						<div class="text-sm">{{ $t('presencas') }}</div>
					</div>
				</div>
				</vx-card>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-4">
				<vx-card>
					<div class="flex items-center mb-2" style="gap: 1rem;">
						<div class="icon-wrapper iw-red">
							<feather-icon icon="UserIcon" class="icon" />
						</div>
						<div>
						<h3 class="text-h3 m-0"><b>{{ faltas() }}</b></h3>
						<div class="text-sm">{{ $t('Faltas') }}</div>
					</div>
				</div>
				</vx-card>
			</div>
		</div>
		
		<div class="w-full mb-8" v-if="show_stats && analytics.length > 0">
            <vx-card class="stats-card">
				<div class="flex mb-5">
                    <span class="flex items-center">
                        <div class="h-3 w-3 rounded-full mr-1" style="background-color: #63c0bb;"></div>
                        <span>{{$t('people_n')}}</span>
                    </span>
                    <span class="flex items-center ml-4">
                        <div class="h-3 w-3 rounded-full mr-1 bg-warning"></div>
                        <span>{{$t('places_n')}}</span>
                    </span>
                </div>
                <div v-for="(item, index) in analytics" :key="index" :class="{'mt-4': index}">
                    <div class="flex justify-between">
                        <div class="flex flex-col">
                            <span class="mb-1">{{item.label}}</span>
                            <h4>{{item.total_current_occupancy}}</h4>
                        </div>
                        <div class="flex flex-col text-right">
                            <span class="flex -mr-1">
                                <span class="mr-1 mt-5">{{item.max_occupancy}}</span>
                            </span>
                        </div>
                    </div>
                    <vs-progress :percent="item.percent"></vs-progress>

					<div class="flex justify-between mt-2">
                        <div class="flex flex-col">
                            <h4>{{item.total_seats_occupancy}}</h4>
                        </div>
                        <div class="flex flex-col text-right">
                            <span class="flex -mr-1">
                                <span class="mr-1">{{item.max_occupancy}}</span>
                            </span>
                        </div>
                    </div>
                    <vs-progress :percent="item.percent_seats" color="warning"></vs-progress>
                </div>
            </vx-card>
		</div>

		<vx-card class="stats-card" v-if="show_stats">
			<div class="lg:w-1/2 w-full">
				<div class="flex items-end space-x-2">
					<div class="w-40">
						<small class="block">{{$t('n_quarto')}}</small>
						<vs-input class="w-full"
								@focus="keyboard_show"
								data-layout="numeric"
								v-model="room_number"/>
					</div>
					<!-- Botão  -->
					<vs-button class="ml-4" color="primary" type="filled" @click="search_rsv()">
						{{$t('Pesquisar')}}
					</vs-button>
				</div>
			</div>
		</vx-card>

		<div class="vx-row mt-8" v-if="show_stats_room">
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-4">
				<vx-card>
					<h4 class="text-h4">{{ $t('reservation') }}</h4>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('rsv_number')}}:</div>
					<div class="text-md">{{ info.reserva.n_reserva }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('nome')}}:</div>
					<div class="text-md">{{ info.reserva.nome }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('room_number')}}:</div>
					<div class="text-md">{{ info.reserva.n_quarto }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">Check-In:</div>
					<div class="text-md">{{ info.reserva.checkin }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">Check-Out:</div>
					<div class="text-md">{{ info.reserva.checkout }}</div>
				</vx-card>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-4">
				<vx-card>
					<h4 class="text-h4">{{ $t('Meals') }}</h4>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('regime')}}:</div>
					<div class="text-md">{{ info.refeicoes.regime }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('adultos')}}:</div>
					<div class="text-md">{{ info.refeicoes.adultos }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('criancas')}}:</div>
					<div class="text-md">{{ info.refeicoes.criancas }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('bebes')}}:</div>
					<div class="text-md">{{ info.refeicoes.bebes }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{service_type_selected['name_'+$i18n.locale]}}:</div>
					<div class="text-md">{{ info.refeicoes.service_type }}</div>
				</vx-card>
			</div>
			<div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-4" v-if="marcacao_card">
				<vx-card>
					<h4 class="text-h4">{{ $t('Marcação') }}</h4>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('space')}}:</div>
					<div class="text-md">{{ space_selected.space_name }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('service')}}:</div>
					<div class="text-md">{{service_type_selected['name_'+$i18n.locale]}}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('horario')}}:</div>
					<div class="text-md">{{ info.marcacao.horario }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('people_n')}}:</div>
					<div class="text-md">{{ info.marcacao.n_pessoas }}</div>
					<br>
					<div class="text-md" style="font-weight: 600">{{$t('n_presenças')}}:</div>
					<div class="text-md">{{ info.marcacao.n_presencas }}</div>
				</vx-card>
			</div>
		</div>

		<vx-card class="stats-card" v-if="show_stats_room">
			<div class="lg:w-1/2 w-full">
				<div class="flex items-end space-x-2">
					<!-- Label + Input agrupados -->
					<div class="flex flex-col">
						<small class="block mb-1">{{$t('n_presenças')}}</small>
						<vs-input-number min="0" v-model="presencas_number"/>
					</div>
					<!-- Botão -->
					<vs-button class="ml-6" style="top: -5px;" color="primary" type="filled" @click="save_presencas()">
						{{$t('Gravar')}}
					</vs-button>

				</div>
			</div>
		</vx-card>


		<vue-touch-keyboard class="v-touch-keyboard" :options="keyboard.options" v-if="keyboard.visible && $route.params.pos == 1 && !isMobile()" :layout="keyboard.layout" :cancel="keyboard_hide" :accept="keyboard_accept" :input="keyboard.input" />

	</div>
</template>

<script>
import { XCircleIcon } from 'vue-feather-icons';
import Datepicker from 'vuejs-datepicker';
import {ptBR} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

import VueTouchKeyboard from "vue-touch-keyboard";
import style from "vue-touch-keyboard/dist/vue-touch-keyboard.css"; // load default style


export default {
	components: {
		XCircleIcon,
		Datepicker,
		vueTouchKeyboard: VueTouchKeyboard.component
	},
	data(){
		return {
			user: JSON.parse(localStorage.getItem('userSession')),
			space_list: [],
			service_type_list: [],
			space_selected: null,
			service_type_selected: null,
			room_selected: null,
			show_stats: false,
			show_stats_room: false,
			room_number: null,
			presencas_number: 0,
			previsao_total: 0,
			marcacoes: 0,
			presencas: 0,
			analytics: [],
			info:{
				reserva: {
					n_reserva: '-',
					nome: '-',
					n_quarto: '-',
					checkin: '-',
					checkout: '-',
				},
				refeicoes: {
					regime: '-',
					adultos: 0,
					criancas: 0,
					bebes: 0,
					service_type: '-',
				},
				marcacao: {
					horario: '-',
					n_pessoas: 0,
					n_presencas: 0,
				}
			},
			total_pessoas: 0,
			marcacao_card: false,
			reservation_distribution_id: null,
	    	keyboard: {
				visible: false,
		      	layout: "normal",
		      	input: null,
		      	options: {
			        useKbEvents: false
			    }
		  	},
		}
	},
	methods: {			

		get_spaces_and_services(){
			this.$vs.loading();
			let that = this;
			
			this.$api({
				method: 'get',
				url: '/myvilagale/appointments/get_spaces',
				params: {
					token: this.user.usertoken,
					cod_hotel: this.user.hotel.hotel_id,
					active: 1,
					space_type_id: 1, // 1 = restaurante
				},
			}).then(function (res) {

				that.space_list = res.data.data;
				if(that.space_list.length > 0){
					that.user.hotel.hotel_name = that.space_list[0].hvg_desc;
				}

				that.$api({
					method: 'get',
					url: '/myvilagale/appointments/get_service_type',
					params: {
						token: that.user.usertoken,
					},
				}).then(function (res) {
					that.service_type_list = res.data;
				}).catch( function (err) {
					that.notify('ERRO 1B', 'red');
				}).then(function() {
					that.$vs.loading.close();
				});

			}).catch( function (err) {
    			that.notify('ERRO 1A', 'red');
			}).then(function() {
    			that.$vs.loading.close();
			});
		},
		get_stats(only_presencas = false, clean_room_number = true){
			this.$vs.loading();
			let that = this;
			if(!only_presencas){
				this.show_stats = false;
				this.show_stats_room = false;
				if(clean_room_number){
					this.room_number = null;
				}
				this.marcacao_card = false;
			}
			this.$api({
				method: 'get',
				url: '/myvilagale/appointments/get_stats',
				params: {
					token: this.user.usertoken,
					hotel_id: this.user.hotel.hotel_id,
					space_hotel_id: this.space_selected.space_hotel_id,
					service_type_id: this.service_type_selected.service_type_id
				},
			}).then(function (res) {
				that.marcacoes = res.data[0]['marcacoes'];
				that.presencas = res.data[0]['presencas'];
				that.previsao_total = res.data[0]['previsao_total'];
				that.get_my_bookings();
			}).catch( function (err) {
				that.show_stats = false;
				that.show_stats_room = false;
				that.room_number = null;
				that.marcacao_card = false;
    			that.notify('ERRO 2A', 'red');
			}).then(function() {
				// if(!only_presencas){
				// 	that.$vs.loading.close();
				// }
			});
		},
		get_my_bookings(){
			let that = this;
			that.$api({
				method: 'get',
				url: '/myvilagale/bookings/get_my_bookings',
				params: {
					token: this.user.usertoken,
					num_reserva: null,
					cod_hotel: this.user.hotel.hotel_id,
					lang: this.$i18n.locale,
					interface: 1,
					filter_date: new Date().toISOString().split('T')[0],
					filter_space_hotel: this.space_selected.space_hotel_id,
					filter_service_type: this.service_type_selected.service_type_id,
					filter_schedule: null,
					filter_num_reserva: null,
					filter_room_number: null,
					filter_name: null,
					filter_group: null,
					service_type_list: 'get',
					onlySpaces: false,
					n_grupo: false,
				},
			}).then(function (res) {
				
				that.analytics = res.data.statistics;
				that.show_stats = true;

			}).catch( function (err) {
				that.notify('ERRO 2B', 'red');
			}).then(function() {
				that.$vs.loading.close();
			});

		},
		faltas() {
    		return Math.max(0, this.previsao_total - this.presencas);
    	},
		search_rsv: function() {
			if(this.room_number == null || this.room_number.trim() == ''){
				this.notify(this.$t('O_n_quarto_obrigatório'), 'red');
				return false;
			}
			let that = this;
			this.marcacao_card = false;
			this.$vs.loading();
			this.$api({
				method: 'get',
				url: '/myvilagale/bookings/search_rsv',
				params: {
					token: this.user.usertoken,
					cod_hotel: this.user.hotel.hotel_id,
					num_reserva: '',
					room_number: this.room_number,
				},
			}).then(function (res) {

				that.info.reserva.n_reserva = res.data.num_reserva;
				that.info.reserva.nome = res.data.nome;
				that.info.reserva.n_quarto = res.data.current_room_number;
				if (res.data.current_data_check_in) {
					const dateParts = res.data.current_data_check_in.split(' ')[0].split('-');
					that.info.reserva.checkin = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
				} else {
					that.info.reserva.checkin = '-';
				}
				if (res.data.current_data_check_out) {
					const dateParts2 = res.data.current_data_check_out.split(' ')[0].split('-');
					that.info.reserva.checkout = `${dateParts2[2]}-${dateParts2[1]}-${dateParts2[0]}`;
				} else {
					that.info.reserva.checkout = '-';
				}
				that.info.refeicoes.adultos = res.data.rooms[0].pessoas;
				that.info.refeicoes.criancas = res.data.rooms[0].num_criancas_pagas;
				that.info.refeicoes.bebes = res.data.rooms[0].num_criancas_gratis;
				that.total_pessoas = 
					parseInt(that.info.refeicoes.adultos) + 
					parseInt(that.info.refeicoes.criancas) + 
					parseInt(that.info.refeicoes.bebes);

				that.meals_info();
			}).catch( function (err) {
				that.show_stats_room = false;
				if(err.response.data.message){
    				that.notify(err.response.data.message, 'red');
				}else{
    				that.notify('ERRO 3A', 'red');
				}
				that.presencas_number = 0;
				that.$vs.loading.close();
			}).then(function() {
			});
		},
		meals_info(only_presencas = false){
			this.info.marcacao.horario = '-';
			this.info.marcacao.n_pessoas = 0;
			this.info.marcacao.n_presencas = 0;
			this.reservation_distribution_id = null;
			let that = this;
			this.$api({
				method: 'get',
				url: '/myvilagale/appointments/meals/info',
				params: {
					token: this.user.usertoken,
					num_reserva: this.info.reserva.n_reserva,
					hotel_id: this.user.hotel.hotel_id,
					space_hotel_id: this.space_selected.space_hotel_id,
					service_type_id: this.service_type_selected.service_type_id,
					only_presencas: only_presencas ? 1 : 0
				},
			}).then(function (res) {

				if(!only_presencas){
					that.info.refeicoes.regime = res.data.regime;
					that.info.refeicoes.service_type = res.data.booking;
				}
				
				if (res.data.marcacao) {
					
					let startTime = res.data.marcacao.start_time;
					if (startTime && startTime.length === 4) {
						startTime = startTime.slice(0, 2) + ':' + startTime.slice(2);
					}
					let endTime = res.data.marcacao.end_time;
					if (endTime && endTime.length === 4) {
						endTime = endTime.slice(0, 2) + ':' + endTime.slice(2);
					}
					that.info.marcacao.horario = that.$t('str_hour_schedule')
						.replace('{start_time}', startTime)
						.replace('{end_time}', endTime);
					that.info.marcacao.n_pessoas = res.data.marcacao.occupancy;
					that.info.marcacao.n_presencas = res.data.marcacao.num_people_show;
					that.presencas_number = res.data.marcacao.num_people_show;
					that.reservation_distribution_id = res.data.marcacao.reservation_distribution_id;
					that.marcacao_card = true;

				} else {
					that.reservation_distribution_id = null;
					that.marcacao_card = false;
					that.presencas_number = 0;
				}
					
			}).catch( function (err) {
				that.notify('ERRO 3B', 'red');
			}).then(function() {
				that.show_stats_room = true;
				if(!only_presencas){
					that.$vs.loading.close();
				}
			});
		},
		save_presencas() {
			let that = this;
			this.$vs.loading();
			this.$api({
				method: 'post',
				url: '/myvilagale/appointments/meals/presencas/save',
				data: {
					token: this.user.usertoken,
					num_reserva: this.reservation_distribution_id ? null : this.info.reserva.n_reserva,
					room_number: this.reservation_distribution_id ? null : this.room_number,
					hotel_id: this.reservation_distribution_id ? null : this.user.hotel.hotel_id,
					space_hotel_id: this.reservation_distribution_id ? null : this.space_selected.space_hotel_id,
					service_type_id: this.reservation_distribution_id ? null : this.service_type_selected.service_type_id,
					n_people: this.total_pessoas,
					n_presencas: this.presencas_number,
					reservation_distribution_id: this.reservation_distribution_id
				}
			}).then(function (res) {
				that.notify(that.$t('save_presencas_sucesso'), 'green');
				if(that.reservation_distribution_id == null){
					that.get_stats(false, false);
				}else{
					that.get_stats(true);
				}
				that.meals_info(true);
			}).catch(function (err) {
				if(err.response.data.message){
					if(err.response.data.message == 'schedule_not_found'){
						that.notify(that.$t('schedule_not_found'), 'red');
					}else if(err.response.data.message == 'invalid_presencas_value'){
						that.notify(that.$t('invalid_presencas_value'), 'red');
					}else{
    					that.notify(err.response.data.message, 'red');
					}
				}else{
					that.notify('ERRO 4A', 'red');
				}
				that.$vs.loading.close();
			}).then(function () {
			});
		},
		keyboard_accept(text) {
          //alert("Input text: " + text);
          this.keyboard_hide();
        },
        keyboard_show(e) {
          this.keyboard.input = e.target;
          this.keyboard.layout = e.target.dataset.layout;
 
          if (!this.keyboard.visible)
            this.keyboard.visible = true
        },
        keyboard_hide() {
          this.keyboard.visible = false;
        }
	},
	computed: {
	},
	watch: {
		space_selected: function(new_val, old_val) {
			if(new_val != null && this.service_type_selected != null){
				this.get_stats();
			}
			if(new_val == null){
				this.show_stats = false;
				this.show_stats_room = false;
			}
		},
		service_type_selected: function(new_val, old_val) {
			if(new_val != null && this.space_selected != null){
				this.get_stats();
			}
			if(new_val == null){
				this.show_stats = false;
				this.show_stats_room = false;
			}
		},
		
	},
	mounted() {
		
	},
	created() {
		this.user = {
			usertoken: this.$route.params.token,
			hotel: {
				hotel_id: this.$route.params.hotelId,
				hotel_name: null,
			}
		};
		
		this.get_spaces_and_services();
	},
}
</script>

<style scoped>
	.table_schedule_wrapper {
		position: relative;
		z-index: 0;
	}
	.table_schedule_wrapper .vs-input-number, .table_dish_wrapper .vs-input-number {
		background-color: transparent;
	}
	.datePickerDiv >>> input {
	  border: none;
	  background: transparent;
	  color: transparent;
	  width: 0;
	  height: 0;
	}
	.datePickerDiv >>> .vdp-datepicker {
	  right: 96px;
	  width: 0;
	  height: 0;
	}
	.datePickerDiv >>> .vdp-datepicker__calendar {
		top: 0;
		z-index: 999;
		height: 282px;
	}
	.datePickerDiv >>> .vdp-datepicker__calendar > div {
		background-color: #ffffff;
	}
	.stats-card >>> .vs-dropdown-menu {
		width: 130px;
	}
	.stats-card .vue-select {
		min-width: 240px;
	}
	.icon-calendar:before {
	    content: "";
	}
	.logo-text{
        font-size: 26px;
        font-weight: 600;
        color: #4A4E4F;
        animation: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) 0s normal forwards 1 fadein;
		font-family: 'Titillium Web',sans-serif;
      }
      @media screen and (max-width: 767.98px) {
      	.meal-management-page  >>>.vx-card__actions {
      		width: 100%;
      		text-align: right;
      	}
      	.stats-card .vue-select, .icon-calendar {
			margin-top: 10px;
		}
		.datePickerDiv >>> .vdp-datepicker {
			right: 10px;
		}
      }
      @media screen and (max-width: 450px) {
      	.datePickerDiv >>> .vdp-datepicker {
			right: -50px;
		}
      }
      @media screen and (max-width: 376px) {
      	.datePickerDiv >>> .vdp-datepicker {
			right: -10px;
		}
      }
	  
	.bookings-table >>> .con-pagination-table .vs-pagination--mb {
		width: 100% !important;
		padding: 0 !important;
	}
	.v-touch-keyboard {
    	z-index: 99999;
    	background-color: #ffffff;
    	position: fixed;
    	width: 70%;
    	left: 0;
	    right: 0;
	    bottom: 0;
	    margin: auto auto;
	    padding: 1em;
	    box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.3);
	    border-radius: 10px;
    }
    .v-touch-keyboard >>> .keyboard .key {
    	font-size: 1.45em;
    }
    @media screen and (max-width: 992px) {
		.v-touch-keyboard {
	    	width: 100%;
		}
	}
	.icon-wrapper {
		width: 48px;
		height: 48px;
		
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.icon-wrapper svg {
		width: 24px;
		height: 24px;
	}
	.iw-purple {
		background-color: #d3bffe; /* Roxo */
	}
	.iw-yellow {
		background-color: #e8fd8e; /* Amarelo */
	}
	.iw-green {
		background-color: #9fffa6; /* Verde */
	}
	.iw-red {
		background-color: #fca1a1; /* Vermelho */
	}

</style>
<style>
    .filter_date .vdp-datepicker__calendar{
    	bottom: inherit;
    }
	.vs-input-number .btn-plus {
		width: 35px;
		height: 35px;
		font-size: 20px;
	}
	.vs-input-number .btn-less {
		width: 35px;
		height: 35px;
		font-size: 20px;
	}
	.vs-input-number input {
		height: 35px; /* ajusta a altura do campo para combinar */
		font-size: 16px;
	}
    
</style>